import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent from "../../../../components/OB/TableComponent";
import ArsaArazim2BirimDegeriSorgulamaAPI from "../../../../apis/OB/Get/ArsaArazim2BirimDegeriSorgulamaAPI";
import CaddeSokakAPI from "../../../../apis/OB/Get/CaddeSokakAPI";

const ArsaAraziM2BirimDegeriSorgulama: React.FC = () => {
  const columnsArsa = [
    { header: "Türü", field: "turu", className: "text-center" },
    { header: "Mahalle Adı", field: "mahalleAdi", className: "text-center" },
    {
      header: "Cadde/ Sokak Adı",
      field: "caddeSokakAdi",
      className: "text-center",
    },
    {
      header: "Kapı No/ Alt Kapı No",
      field: "kapiAltKapiNo",
      className: "text-center",
    },
    { header: "Ada/ Parsel", field: "adaParsel", className: "text-center" },
    {
      header: "Arsa m2 Birim Değeri",
      field: "arsaM2BirimDegeri",
      className: "text-center",
    },
  ];
  const columnsArazi = [
    { header: "Türü", field: "turu", className: "text-center" },
    { header: "Mahalle Adı", field: "mahalleAdi", className: "text-center" },
    {
      header: "Cadde/ Sokak Adı",
      field: "caddeSokakAdi",
      className: "text-center",
    },
    {
      header: "Kapı No/ Alt Kapı No",
      field: "kapiAltKapiNo",
      className: "text-center",
    },
    { header: "Ada/ Parsel", field: "adaParsel", className: "text-center" },
    { header: "Taban Değeri", field: "tabanDegeri", className: "text-center" },
    { header: "Kurak Değeri", field: "kurakDegeri", className: "text-center" },
    { header: "Kıraç Değeri", field: "kiracDegeri", className: "text-center" },
    { header: "Sulak Değeri", field: "sulakDegeri", className: "text-center" },
    { header: "Diğer Değeri", field: "digerDeger", className: "text-center" },
  ];

  const [data, setData] = useState<any[]>([]);

  const [searchControl, setSearchControl] = useState<boolean>(true);
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const { yilListe, mahalleListe } = useContext(ConstantAPISContext);
  const [selectedYear, setSelectedYear] = useState(
    Number(new Date().getFullYear())
  );
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<any>();
  const [selectedCaddeSokakKodu, setSelectedCaddeSokakKodu] =
    useState<any>(undefined);
  const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
  const [selectedType, setSelectedType] = useState(1);
  const [isLoading, setisLoading] = useState<boolean>(false);

  //CaddeSokakAPI
  useEffect(() => {
    if (
      selectedMahalleKodu !== undefined &&
      !Number.isNaN(selectedMahalleKodu)
    ) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeSokakDatas(res.data);
        })
        .catch((err) => { });
    }
  }, [selectedMahalleKodu]);
  //ArsaArazim2BirimDegeriSorgulamaAPI

  useEffect(() => {
    if (
      selectedYear !== 0 &&
      selectedMahalleKodu != undefined
    )
      fetchData();
  }, [selectedType]);



  const fetchData = async (isPass: boolean = true) => {

    if (selectedYear !== 0 && selectedMahalleKodu != undefined) {
      setisLoading(true);
      const response =
        await ArsaArazim2BirimDegeriSorgulamaAPI.getArsaAraziM2BirimDegeriSorgulama(
          selectedYear,
          selectedMahalleKodu,
          selectedCaddeSokakKodu,
          selectedType
        );
      setData(response.data);
      setTimeout(() => {
        setisLoading(false);

      }, 100)
      setSearchControl(true);
      setIsSearched(true);

    } else {
      setSearchControl(false);
      showToast("Yıl ve mahalle alanları zorunludur.", "error");
    }
  };

  const handleTemizle = () => {
    setSelectedYear(Number(new Date().getFullYear()));
    setSelectedCaddeSokakKodu(undefined);
    setSelectedMahalleKodu(undefined);
    setSelectedType(1);
  };

  //Formik constantları
  const initialValues = {
    //boş kalacak ihtiyaca göre kullanılabilir
  };
  return (
    <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
      <div className="card-body p-0">
        <Formik initialValues={initialValues} onSubmit={() => { }}>
          <Form id="kayit-form" className="d-flex w-100 mb-4">
            <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
              <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id="">Yıl</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    name="yil"
                    label="yil"
                    error={
                      selectedYear == undefined && searchControl == false
                        ? true
                        : false
                    }
                    value={selectedYear || ""}
                    onChange={(e) => {
                      setSelectedYear(Number(e.target.value || undefined));
                    }}
                  >
                    {yilListe.map((item) => (
                      <MenuItem key={item} value={item.yili}>
                        {item.yili}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id="">Mahalle</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    error={
                      selectedMahalleKodu == undefined && searchControl == false
                        ? true
                        : false
                    }
                    value={selectedMahalleKodu || ""}
                    label="Mahalle"
                    onChange={(e) => {
                      setSelectedMahalleKodu(
                        Number(e.target.value || undefined)
                      );
                      setSelectedCaddeSokakKodu(undefined);
                    }}
                  >
                    {mahalleListe.map((item) => (
                      <MenuItem key={item} value={item.mahalleKodu}>
                        {item.mahalleAdi}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id="">Cadde/Sokak</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    value={selectedCaddeSokakKodu || ""}
                    label="Cadde/Sokak"
                    onChange={(e) => {
                      setSelectedCaddeSokakKodu(
                        Number(e.target.value || undefined)
                      );
                    }}
                  >
                    {caddeSokakDatas.map((item) => (
                      <MenuItem key={item} value={item.caddeSokakKodu}>
                        {item.caddeSokakAdi}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small"
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "50%",
                      md: "25%",
                    },
                    minWidth: 140
                  }}>

                  <InputLabel id=""></InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "white",
                    }}
                    labelId=""
                    id=""
                    value={selectedType || ""}
                    label=""
                    onChange={(e) => {
                      setSelectedType(Number(e.target.value));
                    }}
                  >
                    <MenuItem selected value={1}>
                      {"Arsa"}
                    </MenuItem>
                    <MenuItem value={2}>{"Arazi"}</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="d-flex  flex-row ms-auto ">
                <SearchComponent
                  fetchData={fetchData}
                  onTemizle={handleTemizle}
                  setData={setData}
                />
              </div>
            </div>
          </Form>
        </Formik>
        {isLoading ?
          <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

            <CircularProgress />
          </div>
          :
          <TableComponent
            isSearched={isSearched}
            columns={selectedType == 1 ? columnsArsa : columnsArazi}
            data={data}
            recordsPerPage={12}
          ></TableComponent>
        }
      </div>
    </div>
  );
};

export default ArsaAraziM2BirimDegeriSorgulama;


